
export const del     = <T>( arr: Array<T>, obj: T ) => arr.filter( el => el !== obj );
export const push    = <T>( arr: Array<T>, obj: T ) => [ ...arr, obj ];
export const prepend = <T>( arr: Array<T>, obj: T ) => [ obj, ...arr ];